import React from 'react';
import { dateUtils } from '@indico-data/utils';
export const DateTimeDisplay = ({ date }) => {
    const dateParts = dateUtils.getDateParts(date);
    if (!dateParts)
        return null;
    return (React.createElement("div", null,
        dateParts.month,
        "-",
        dateParts.day,
        "-",
        dateParts.year,
        "\u00A0",
        React.createElement("wbr", null),
        dateParts.hour,
        ":",
        dateParts.minute,
        dateParts.dayPeriod));
};
//# sourceMappingURL=DateTimeDisplay.js.map